export default __webpack_public_path__ + "static/jmb_transaction-63d49f0946d7290a68584bbb00eb48ca.png";